<template>
  <v-dialog
    v-model="showDialog"
    :fullscreen="fullScreen"
    hide-overlay
    @click:outside="$emit('closed')"
  >
    <v-card
      item
    >
      <v-app-bar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ $t('Select {0}', [$t('Customer')]) }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            dark
            icon
            @click.native="$emit('closed')"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-app-bar>
      <v-card-text class="pt-6">
        <customers-table
          v-if="showDialog"
          :focus-input="showDialog"
          include-search
          @item-saved="$emit('item-saved', $event)"
          @item-selected="$emit('item-selected', $event)"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CustomersTable from '@/components/customers/CustomersTable'
export default {
  name: 'SelectCustomerDialog',

  components: {
    CustomersTable
  },

  props: {
    fullScreen: {
      type: Boolean,
      default: true
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/SelectCustomerDialog.vue